import React, { Component } from 'react';

const withContext = (Context, storeArgs) => BaseComponent =>
  class extends Component {
    state = {
      store: storeArgs
    };

    insertStore = newData => {
      this.setState({
        store: { ...this.state.store,...newData }
      });
    };

    getStore = params => {
      const { store } = this.state;
      if (!store[ params ]) return '';
      return store[ params ];
    };

    render() {
      const { store } = this.state;
      return (
        <Context.Provider
          value={ {
            store,
            insertStore: this.insertStore,
            getStore: this.getStore
          } }>
          <BaseComponent { ...this.props } />
        </Context.Provider>
      );
    }
  };

export default withContext;
